const Images = {
  description: require('./description.svg'),
  // logo: require('./logo.svg'),
  // kyberLogo: require('./kyber-logo.png'),
  // // background
  // bgBtcRanking: {
  //   en: require('./bg/btc-ranking-bg-en.jpg'),
  //   jp: require('./bg/btc-ranking-bg-jp.jpg'),
  //   cn: require('./bg/btc-ranking-bg-cn.jpg'),
  // },
  // bgPredict: {
  //   en: require('./bg/predict-bg-en.jpg'),
  //   jp: require('./bg/predict-bg-jp.jpg'),
  //   cn: require('./bg/predict-bg-cn.jpg'),
  // },
  // bgBtcRankingMb: require('./bg/btc-ranking-bg-mb.jpg'),
  // bgPredictMb: require('./bg/predict-bg-mb.jpg'),
  // contactUs: require('./bg/contact-us.png'),
  // // icon
  // icMenu: require('./icon/menu.svg'),
  // icMenuClose: require('./icon/menu-close.svg'),
  // icArrowRight: require('./icon/arrow-right.svg'),
  // icArrowDown: require('./icon/arrow-down.svg'),
  // icDelete: require('./icon/delete.svg'),
  // icJoined: require('./icon/joined.svg'),
  // icLost: require('./icon/lost.svg'),
  // icWon: require('./icon/won.svg'),
  // icQuestion: require('./icon/question.svg'),
  // icBitcoin: require('./icon/bitcoin.png'),
  // icEther: require('./icon/ether.png'),
  // icHistory: require('./icon/history.svg'),
  // tokenNone: require('./icon/tokenNone.svg'),
  // yourDeposit: require('./icon/your-deposit.svg'),
  // availableAmount: require('./icon/available-amount.svg'),
  // lockupAmount: require('./icon/lockup-amount.svg'),
  // icChecked: require('./icon/checked.svg'),
  // Ellipse: require('./Ellipse13.svg'),
  // VectorTop: require('./VectorTop.svg'),
  // deleteIcon: require('./deleteIcon.svg'),
  // withdraw: require('./deposit/withdraw.jpg'),
  // blockchain: require('./deposit/blockchain.jpg'),
  // collected: require('./deposit/collected.jpg'),
  // depositIcon: require('./depositIcon.svg'),
  // currentDeposit: require('./currentDeposit.svg'),
  // daiIcon: require('./icon/dai_stablecoin.png'),
  // withdrawal: require('./withdrawal.svg'),
  // FailIcon: require('./FailIcon.svg'),
  // gifBitcoinGaCha: require('./gif/bitcoin-gacha1.gif'),
  // bgGachaQuote: require('./bg/gacha-quote.png'),
  // iconPerformance: require('./icon/average-performance.svg'),
  // iconTarget: require('./icon/target.svg'),
  // iconTotal: require('./icon/total-deposit.svg'),
  // iconFire: require('./icon/streak.svg'),
  // iconQuestion: require('./icon/icon-question.svg'),
  // iconEdit: require('./icon/edit.svg'),
  // iconEditDisable: require('./icon/edit-disable.svg'),
  // iconStar: require('./icon/star.svg'),
  // gameCondition: require('./how-it-works/game-condition.png'),
  // aboutGame: require('./how-it-works/about-game.png'),
  // siteOperation: require('./how-it-works/site-operation.png'),
  // howToPlay: require('./how-it-works/how-to-play.png'),
  // topPlayers: require('./how-it-works/top-players.png'),
  // whatMore: require('./how-it-works/what-more.png'),
  // howItWorks: {
  //   en: require('./how-it-works/how-it-works-en.png'),
  //   jp: require('./how-it-works/how-it-works-jp.png'),
  //   cn: require('./how-it-works/how-it-works-cn.png'),
  // },
  // anonymous: require('./how-it-works/anonymous.png'),
  // costless: require('./how-it-works/costless.png'),
  // transparent: require('./how-it-works/transparent.png'),
  // unlimited: require('./how-it-works/unlimited.png'),
  // note1: require('./how-it-works/note1.svg'),
  // note2: require('./how-it-works/note2.svg'),
  // note3: require('./how-it-works/note3.svg')
}
export default Images